import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAspectRatio219: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="aspect-ratio-21-9, wide, landscape"><path d="M3.75 6C1.67893 6 0 7.67893 0 9.75V14.25C0 16.3211 1.67893 18 3.75 18H20.25C22.3211 18 24 16.3211 24 14.25V9.75C24 7.67893 22.3211 6 20.25 6H3.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconAspectRatio219;
